export class ChargeRangeDTO {
    constructor(
        public minPartySize: number | null,
        public maxPartySize: number | null,
        public unitAmount: number | null,
        public isPerCover: boolean,
        public startDate: string | null,
        public endDate: string | null,
        public cutOffHours: number | null
    ) { }
}
